// extracted by mini-css-extract-plugin
export default {"checkbox":"style_checkbox__2LAwo"};